import { useState, useEffect } from "react"

import { useAppContext } from "providers/AppProvider/AppProvider"
import { useUI } from "providers/UIProvider"

import CompanyBranchesCount from "./CompanyBranchesCount"
import { Box, Flex, Image, Text, Spinner } from "@chakra-ui/react"
import Dropdown from "components/UI/atoms/Dropdown"
import Icon from "components/UI/atoms/Icon"
import useCompanyBranches from "hooks/useCompanyBranches"


interface props {
  width?: string
}

const CompanyBranchesForHolidays = ({ width = "306px" }: props) => {
  const { T, modals } = useUI()
  const { selectedBranchesForHolidays, updateSelectedBranchesForHolidays, branchesSearchValue, updateBranchesSearchValue, branches } = useAppContext()
  const { isAdmin, laundryBranchesDataLoading, branchOptions, selectAll, setSelectAll } = useCompanyBranches()
  const [dropdownOpened, toggleDropdown] = useState<boolean>(false)
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectAll(false)
      updateSelectedBranchesForHolidays([])
    } else {
      setSelectAll(true)
      updateSelectedBranchesForHolidays(branchOptions.map((item: any) => item.id))
    }

    toggleDropdown(false)
  }
  const handleSelectItem = (val: number) => {
    let updatedSelectedBranches = []
    let updatedSelectAll = selectAll

    if (selectedBranchesForHolidays.includes(val)) {
      updatedSelectedBranches = selectedBranchesForHolidays.filter((item) => item !== val)
    } else {
      updatedSelectedBranches = [...selectedBranchesForHolidays, val]
    }
    if (updatedSelectedBranches.length === branchOptions.length) {
      updatedSelectAll = true
    } else {
      updatedSelectAll = false
    }
    updateSelectedBranchesForHolidays(updatedSelectedBranches)
    setSelectAll(updatedSelectAll)
  }

  useEffect(() => {
    if (selectedBranchesForHolidays.length === 0) {
      updateSelectedBranchesForHolidays(branches?.data.map((branch: { id: number }) => branch.id))
      setSelectAll(true)
    } else if (selectedBranchesForHolidays.length === branches?.data.map((branch: { id: number }) => branch.id).length) {
      setSelectAll(true)
    } else {
      setSelectAll(false)
    }
  }, [modals.holidaysModalForQappAdmin, modals.addAdminEditHolidayModal])
  const selectedBranch = selectedBranchesForHolidays.length === 1 && branchOptions.find((branchOption) => branchOption.id && selectedBranchesForHolidays.includes(branchOption.id)) || null
  const logoUrl = selectedBranch?.leftImg
  const title = selectedBranch?.label
  return (
    <Box position="relative" width="306px" height="58px">
      {selectedBranchesForHolidays?.length > 1 && (
        <CompanyBranchesCount
          count={selectedBranchesForHolidays.length}
          onClick={() => toggleDropdown(true)}
          dropdownOpened={dropdownOpened}
          selectedAll={selectAll}
        />
      )}
      {selectedBranchesForHolidays?.length < 2 && (
        <Box
          width={width}
          height="58px"
          as="button"
          backgroundColor="white"
          borderRadius="base"
          borderBottomRadius={dropdownOpened ? "0" : "base"}
          pointerEvents={dropdownOpened ? "none" : "auto"}
          boxShadow="primary"
          fontSize="base"
          fontFamily="heading"
          padding="0 15px"
          onClick={() => toggleDropdown(true)}
        >
          <Flex width="100%" height="100%" alignItems="center">
            {selectedBranchesForHolidays.length > 0 && <Image src={logoUrl} alt="Company" width="45px" />}
            <Text ml="20px" mr="20px">
              {selectedBranchesForHolidays.length === 0 ? T("general.select_branches") : title}
            </Text>
            {isAdmin && <Icon name="dropdown" iconStyles={{ fill: "#00000" }} />}
            {isAdmin && laundryBranchesDataLoading && <Spinner />}
          </Flex>
        </Box>
      )}
      {isAdmin && (
        <Dropdown
          height="25rem"
          width="18.75rem"
          selectable
          selectAll={selectAll}
          handleSelectItem={handleSelectItem}
          handleSelectAll={handleSelectAll}
          searchable
          selected={selectedBranch?.id?.toString()}
          selectedItems={selectedBranchesForHolidays}
          searchValue={branchesSearchValue}
          onSearch={(val) => updateBranchesSearchValue(val)}
          searchPlaceholder={T("general.search_for_company")}
          opened={dropdownOpened}
          toggleOpened={toggleDropdown}
          items={branchOptions}
          styles={{
            top: "59px",
            fontWeight: "bold",
          }}
        />
      )}
    </Box>
  )
}

export default CompanyBranchesForHolidays
